/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AffectedQuotesResponse,
  AttachSubsidiaryCommandDto,
  CreateLegalEntityCommandDto,
  CreateNaturalPersonCommandDto,
  CreateSubsidiaryCommandDto,
  ErrorResponse,
  GetActorReferentialResponse,
  GetAssureDetailsResponse,
  GetConnectedUserInfosResponse,
  GetGenericListCommandDto,
  GetInsuredListResponseDto,
  GetInsuredsList404Response,
  GetPersonByIDResponse,
  GetSubsidiariesResponse,
  IsDataExistingCommandDto,
  OperationResponse,
  SearchInsuredCommandDto,
  SearchInsuredsResponse,
  StoredFileIdRequest,
  SubsidiariesTotalsDto,
  UpdateLegalEntityFinancialsCommandDto,
  UpdateSubsidiaryCommandDto,
  UpsertMinimalLegalEntityCommandDto,
  UpsertMinimalNaturalPersonCommandDto,
} from '../models/index';
import {
    AffectedQuotesResponseFromJSON,
    AffectedQuotesResponseToJSON,
    AttachSubsidiaryCommandDtoFromJSON,
    AttachSubsidiaryCommandDtoToJSON,
    CreateLegalEntityCommandDtoFromJSON,
    CreateLegalEntityCommandDtoToJSON,
    CreateNaturalPersonCommandDtoFromJSON,
    CreateNaturalPersonCommandDtoToJSON,
    CreateSubsidiaryCommandDtoFromJSON,
    CreateSubsidiaryCommandDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetActorReferentialResponseFromJSON,
    GetActorReferentialResponseToJSON,
    GetAssureDetailsResponseFromJSON,
    GetAssureDetailsResponseToJSON,
    GetConnectedUserInfosResponseFromJSON,
    GetConnectedUserInfosResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetInsuredListResponseDtoFromJSON,
    GetInsuredListResponseDtoToJSON,
    GetInsuredsList404ResponseFromJSON,
    GetInsuredsList404ResponseToJSON,
    GetPersonByIDResponseFromJSON,
    GetPersonByIDResponseToJSON,
    GetSubsidiariesResponseFromJSON,
    GetSubsidiariesResponseToJSON,
    IsDataExistingCommandDtoFromJSON,
    IsDataExistingCommandDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SearchInsuredCommandDtoFromJSON,
    SearchInsuredCommandDtoToJSON,
    SearchInsuredsResponseFromJSON,
    SearchInsuredsResponseToJSON,
    StoredFileIdRequestFromJSON,
    StoredFileIdRequestToJSON,
    SubsidiariesTotalsDtoFromJSON,
    SubsidiariesTotalsDtoToJSON,
    UpdateLegalEntityFinancialsCommandDtoFromJSON,
    UpdateLegalEntityFinancialsCommandDtoToJSON,
    UpdateSubsidiaryCommandDtoFromJSON,
    UpdateSubsidiaryCommandDtoToJSON,
    UpsertMinimalLegalEntityCommandDtoFromJSON,
    UpsertMinimalLegalEntityCommandDtoToJSON,
    UpsertMinimalNaturalPersonCommandDtoFromJSON,
    UpsertMinimalNaturalPersonCommandDtoToJSON,
} from '../models/index';

export interface AttachSubsidiaryRequest {
    personneMoraleId: string;
    attachSubsidiaryCommandDto: AttachSubsidiaryCommandDto;
}

export interface CreateLegalEntityRequest {
    createLegalEntityCommandDto: CreateLegalEntityCommandDto;
}

export interface CreateNaturalPersonRequest {
    createNaturalPersonCommandDto: CreateNaturalPersonCommandDto;
}

export interface CreatePersonDocumentsRequest {
    personId: string;
    storedFileIdRequest: StoredFileIdRequest;
}

export interface CreateSubsidiaryRequest {
    personneMoraleId: string;
    createSubsidiaryCommandDto: CreateSubsidiaryCommandDto;
}

export interface DeletePersonDocumentRequest {
    personId: string;
    storedFileId: string;
}

export interface DetachSubsidiaryRequest {
    personneMoraleId: string;
    filialeId: string;
}

export interface GetAffectedQuotesByPersonIdRequest {
    personId: string;
}

export interface GetInsuredDetailsRequest {
    personneId: string;
}

export interface GetInsuredsListRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetPersonByIDRequest {
    personId: string;
    includeDocuments?: boolean;
}

export interface GetProductOwnersRequest {
    skipCount?: number;
    maxResultCount?: number;
    sorting?: string;
    filter?: string;
}

export interface GetSubsidiariesRequest {
    personneMoraleId: string;
}

export interface GetSubsidiariesTotalsRequest {
    personneMoraleId: string;
}

export interface IsDataExistingRequest {
    isDataExistingCommandDto: IsDataExistingCommandDto;
}

export interface SearchInsuredRequest {
    searchInsuredCommandDto: SearchInsuredCommandDto;
}

export interface UpdateLegalEntityFinancialsRequest {
    personneMoraleId: string;
    updateLegalEntityFinancialsCommandDto: UpdateLegalEntityFinancialsCommandDto;
}

export interface UpdateSubsidiaryRequest {
    personneMoraleId: string;
    filialeId: string;
    updateSubsidiaryCommandDto: UpdateSubsidiaryCommandDto;
}

export interface UpsertMinimalLegalEntityRequest {
    upsertMinimalLegalEntityCommandDto: UpsertMinimalLegalEntityCommandDto;
}

export interface UpsertMinimalNaturalPersonRequest {
    upsertMinimalNaturalPersonCommandDto: UpsertMinimalNaturalPersonCommandDto;
}

/**
 * 
 */
export class ActorsApi extends runtime.BaseAPI {

    /**
     * Declares an existing legal entity as a subsidiary. Name and SIRET are taken from that legal entity.
     * Attach an existing legal entity as a subsidiary
     */
    async attachSubsidiaryRaw(requestParameters: AttachSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling attachSubsidiary().'
            );
        }

        if (requestParameters['attachSubsidiaryCommandDto'] == null) {
            throw new runtime.RequiredError(
                'attachSubsidiaryCommandDto',
                'Required parameter "attachSubsidiaryCommandDto" was null or undefined when calling attachSubsidiary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales/rattacher`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachSubsidiaryCommandDtoToJSON(requestParameters['attachSubsidiaryCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Declares an existing legal entity as a subsidiary. Name and SIRET are taken from that legal entity.
     * Attach an existing legal entity as a subsidiary
     */
    async attachSubsidiary(requestParameters: AttachSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.attachSubsidiaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a legal entity.
     * Create a legal entity
     */
    async createLegalEntityRaw(requestParameters: CreateLegalEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createLegalEntityCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createLegalEntityCommandDto',
                'Required parameter "createLegalEntityCommandDto" was null or undefined when calling createLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures-optim/pm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLegalEntityCommandDtoToJSON(requestParameters['createLegalEntityCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a legal entity.
     * Create a legal entity
     */
    async createLegalEntity(requestParameters: CreateLegalEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createLegalEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a natural person.
     * Create an natural person
     */
    async createNaturalPersonRaw(requestParameters: CreateNaturalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createNaturalPersonCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createNaturalPersonCommandDto',
                'Required parameter "createNaturalPersonCommandDto" was null or undefined when calling createNaturalPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures-optim/pp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNaturalPersonCommandDtoToJSON(requestParameters['createNaturalPersonCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a natural person.
     * Create an natural person
     */
    async createNaturalPerson(requestParameters: CreateNaturalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createNaturalPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create file for person
     */
    async createPersonDocumentsRaw(requestParameters: CreatePersonDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling createPersonDocuments().'
            );
        }

        if (requestParameters['storedFileIdRequest'] == null) {
            throw new runtime.RequiredError(
                'storedFileIdRequest',
                'Required parameter "storedFileIdRequest" was null or undefined when calling createPersonDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/personnes/{personId}/documents`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoredFileIdRequestToJSON(requestParameters['storedFileIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create file for person
     */
    async createPersonDocuments(requestParameters: CreatePersonDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createPersonDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Declares a new subsidiary under the legal entity.
     * Create a subsidiary
     */
    async createSubsidiaryRaw(requestParameters: CreateSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling createSubsidiary().'
            );
        }

        if (requestParameters['createSubsidiaryCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createSubsidiaryCommandDto',
                'Required parameter "createSubsidiaryCommandDto" was null or undefined when calling createSubsidiary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubsidiaryCommandDtoToJSON(requestParameters['createSubsidiaryCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Declares a new subsidiary under the legal entity.
     * Create a subsidiary
     */
    async createSubsidiary(requestParameters: CreateSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createSubsidiaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create file for person
     */
    async deletePersonDocumentRaw(requestParameters: DeletePersonDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deletePersonDocument().'
            );
        }

        if (requestParameters['storedFileId'] == null) {
            throw new runtime.RequiredError(
                'storedFileId',
                'Required parameter "storedFileId" was null or undefined when calling deletePersonDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/personnes/{personId}/documents/{storedFileId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"storedFileId"}}`, encodeURIComponent(String(requestParameters['storedFileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create file for person
     */
    async deletePersonDocument(requestParameters: DeletePersonDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deletePersonDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes the subsidiary from the legal entity.
     * Remove a subsidiary
     */
    async detachSubsidiaryRaw(requestParameters: DetachSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling detachSubsidiary().'
            );
        }

        if (requestParameters['filialeId'] == null) {
            throw new runtime.RequiredError(
                'filialeId',
                'Required parameter "filialeId" was null or undefined when calling detachSubsidiary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales/{filialeId}`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))).replace(`{${"filialeId"}}`, encodeURIComponent(String(requestParameters['filialeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Removes the subsidiary from the legal entity.
     * Remove a subsidiary
     */
    async detachSubsidiary(requestParameters: DetachSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.detachSubsidiaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this person
     * Get affected quotes by person ID
     */
    async getAffectedQuotesByPersonIdRaw(requestParameters: GetAffectedQuotesByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedQuotesResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getAffectedQuotesByPersonId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/personnes/{personId}/devis-impactes`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of quotes that would be affected by modifications to this person
     * Get affected quotes by person ID
     */
    async getAffectedQuotesByPersonId(requestParameters: GetAffectedQuotesByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedQuotesResponse> {
        const response = await this.getAffectedQuotesByPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get connected user infos.
     * Get connected user infos
     */
    async getConnectedUserInfosRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConnectedUserInfosResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/user-connected-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConnectedUserInfosResponseFromJSON(jsonValue));
    }

    /**
     * Get connected user infos.
     * Get connected user infos
     */
    async getConnectedUserInfos(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConnectedUserInfosResponse> {
        const response = await this.getConnectedUserInfosRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the header and details of an insured person
     * Get insured person details
     */
    async getInsuredDetailsRaw(requestParameters: GetInsuredDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssureDetailsResponse>> {
        if (requestParameters['personneId'] == null) {
            throw new runtime.RequiredError(
                'personneId',
                'Required parameter "personneId" was null or undefined when calling getInsuredDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/personnes/{personneId}/details`.replace(`{${"personneId"}}`, encodeURIComponent(String(requestParameters['personneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssureDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Returns the header and details of an insured person
     * Get insured person details
     */
    async getInsuredDetails(requestParameters: GetInsuredDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssureDetailsResponse> {
        const response = await this.getInsuredDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get insureds list
     */
    async getInsuredsListRaw(requestParameters: GetInsuredsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInsuredListResponseDto>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getInsuredsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInsuredListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get insureds list
     */
    async getInsuredsList(requestParameters: GetInsuredsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInsuredListResponseDto> {
        const response = await this.getInsuredsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get person by ID
     */
    async getPersonByIDRaw(requestParameters: GetPersonByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPersonByIDResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPersonByID().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeDocuments'] != null) {
            queryParameters['includeDocuments'] = requestParameters['includeDocuments'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/personnes/{personId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPersonByIDResponseFromJSON(jsonValue));
    }

    /**
     * Get person by ID
     */
    async getPersonByID(requestParameters: GetPersonByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPersonByIDResponse> {
        const response = await this.getPersonByIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of the Personnes that can own a product (accounts holding the offer design brick, companies and managers with or without account), deduplicated by Personne. The filter applies to the label.
     * Get paginated list of product owners
     */
    async getProductOwnersRaw(requestParameters: GetProductOwnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActorReferentialResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skipCount'] != null) {
            queryParameters['SkipCount'] = requestParameters['skipCount'];
        }

        if (requestParameters['maxResultCount'] != null) {
            queryParameters['MaxResultCount'] = requestParameters['maxResultCount'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['Sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/acteurs/liste/proprietaires-produits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActorReferentialResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of the Personnes that can own a product (accounts holding the offer design brick, companies and managers with or without account), deduplicated by Personne. The filter applies to the label.
     * Get paginated list of product owners
     */
    async getProductOwners(requestParameters: GetProductOwnersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActorReferentialResponse> {
        const response = await this.getProductOwnersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the financial data of the parent legal entity, its subsidiaries and the totals.
     * Get the subsidiaries of a legal entity
     */
    async getSubsidiariesRaw(requestParameters: GetSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubsidiariesResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling getSubsidiaries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubsidiariesResponseFromJSON(jsonValue));
    }

    /**
     * Returns the financial data of the parent legal entity, its subsidiaries and the totals.
     * Get the subsidiaries of a legal entity
     */
    async getSubsidiaries(requestParameters: GetSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubsidiariesResponse> {
        const response = await this.getSubsidiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the cumulated revenue and employees of the parent legal entity and its subsidiaries.
     * Get the subsidiaries totals of a legal entity
     */
    async getSubsidiariesTotalsRaw(requestParameters: GetSubsidiariesTotalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubsidiariesTotalsDto>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling getSubsidiariesTotals().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales/cumul`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubsidiariesTotalsDtoFromJSON(jsonValue));
    }

    /**
     * Returns the cumulated revenue and employees of the parent legal entity and its subsidiaries.
     * Get the subsidiaries totals of a legal entity
     */
    async getSubsidiariesTotals(requestParameters: GetSubsidiariesTotalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubsidiariesTotalsDto> {
        const response = await this.getSubsidiariesTotalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verifies the existence of actor data using a search string and filter criteria
     * Check if data exists based on search criteria
     */
    async isDataExistingRaw(requestParameters: IsDataExistingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['isDataExistingCommandDto'] == null) {
            throw new runtime.RequiredError(
                'isDataExistingCommandDto',
                'Required parameter "isDataExistingCommandDto" was null or undefined when calling isDataExisting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/datas-exist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IsDataExistingCommandDtoToJSON(requestParameters['isDataExistingCommandDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Verifies the existence of actor data using a search string and filter criteria
     * Check if data exists based on search criteria
     */
    async isDataExisting(requestParameters: IsDataExistingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.isDataExistingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for insurance actors with filtering, pagination and sorting capabilities
     * Search for insurance actors
     */
    async searchInsuredRaw(requestParameters: SearchInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchInsuredsResponse>> {
        if (requestParameters['searchInsuredCommandDto'] == null) {
            throw new runtime.RequiredError(
                'searchInsuredCommandDto',
                'Required parameter "searchInsuredCommandDto" was null or undefined when calling searchInsured().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchInsuredCommandDtoToJSON(requestParameters['searchInsuredCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchInsuredsResponseFromJSON(jsonValue));
    }

    /**
     * Search for insurance actors with filtering, pagination and sorting capabilities
     * Search for insurance actors
     */
    async searchInsured(requestParameters: SearchInsuredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchInsuredsResponse> {
        const response = await this.searchInsuredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts the financial data of the legal entity for the given fiscal year.
     * Update the financial data of a legal entity
     */
    async updateLegalEntityFinancialsRaw(requestParameters: UpdateLegalEntityFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling updateLegalEntityFinancials().'
            );
        }

        if (requestParameters['updateLegalEntityFinancialsCommandDto'] == null) {
            throw new runtime.RequiredError(
                'updateLegalEntityFinancialsCommandDto',
                'Required parameter "updateLegalEntityFinancialsCommandDto" was null or undefined when calling updateLegalEntityFinancials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/donnees-comptables`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLegalEntityFinancialsCommandDtoToJSON(requestParameters['updateLegalEntityFinancialsCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Upserts the financial data of the legal entity for the given fiscal year.
     * Update the financial data of a legal entity
     */
    async updateLegalEntityFinancials(requestParameters: UpdateLegalEntityFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateLegalEntityFinancialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a subsidiary. Name and SIRET cannot change when the subsidiary is attached to an existing legal entity.
     * Update a subsidiary
     */
    async updateSubsidiaryRaw(requestParameters: UpdateSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['personneMoraleId'] == null) {
            throw new runtime.RequiredError(
                'personneMoraleId',
                'Required parameter "personneMoraleId" was null or undefined when calling updateSubsidiary().'
            );
        }

        if (requestParameters['filialeId'] == null) {
            throw new runtime.RequiredError(
                'filialeId',
                'Required parameter "filialeId" was null or undefined when calling updateSubsidiary().'
            );
        }

        if (requestParameters['updateSubsidiaryCommandDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubsidiaryCommandDto',
                'Required parameter "updateSubsidiaryCommandDto" was null or undefined when calling updateSubsidiary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/personnes-morales/{personneMoraleId}/filiales/{filialeId}`.replace(`{${"personneMoraleId"}}`, encodeURIComponent(String(requestParameters['personneMoraleId']))).replace(`{${"filialeId"}}`, encodeURIComponent(String(requestParameters['filialeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubsidiaryCommandDtoToJSON(requestParameters['updateSubsidiaryCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Updates a subsidiary. Name and SIRET cannot change when the subsidiary is attached to an existing legal entity.
     * Update a subsidiary
     */
    async updateSubsidiary(requestParameters: UpdateSubsidiaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateSubsidiaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a legal entity with minimal required fields (company name, email). If id is provided, updates the existing entity; otherwise creates a new one.
     * Upsert a minimal legal entity
     */
    async upsertMinimalLegalEntityRaw(requestParameters: UpsertMinimalLegalEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['upsertMinimalLegalEntityCommandDto'] == null) {
            throw new runtime.RequiredError(
                'upsertMinimalLegalEntityCommandDto',
                'Required parameter "upsertMinimalLegalEntityCommandDto" was null or undefined when calling upsertMinimalLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures-optim/pm/minimal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertMinimalLegalEntityCommandDtoToJSON(requestParameters['upsertMinimalLegalEntityCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates or updates a legal entity with minimal required fields (company name, email). If id is provided, updates the existing entity; otherwise creates a new one.
     * Upsert a minimal legal entity
     */
    async upsertMinimalLegalEntity(requestParameters: UpsertMinimalLegalEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.upsertMinimalLegalEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a natural person with minimal required fields (name, first name, email, birth date). If id is provided, updates the existing person; otherwise creates a new one.
     * Upsert a minimal natural person
     */
    async upsertMinimalNaturalPersonRaw(requestParameters: UpsertMinimalNaturalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['upsertMinimalNaturalPersonCommandDto'] == null) {
            throw new runtime.RequiredError(
                'upsertMinimalNaturalPersonCommandDto',
                'Required parameter "upsertMinimalNaturalPersonCommandDto" was null or undefined when calling upsertMinimalNaturalPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/acteurs/assures-optim/pp/minimal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertMinimalNaturalPersonCommandDtoToJSON(requestParameters['upsertMinimalNaturalPersonCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates or updates a natural person with minimal required fields (name, first name, email, birth date). If id is provided, updates the existing person; otherwise creates a new one.
     * Upsert a minimal natural person
     */
    async upsertMinimalNaturalPerson(requestParameters: UpsertMinimalNaturalPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.upsertMinimalNaturalPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
